export const REQUIRED_FIELDS_MESSAGE = 'Please fill in all required fields.';

export function formatMissingFieldsMessage(labels: string[]): string {
  const names = labels.map((label) => label.trim()).filter(Boolean);
  if (names.length === 0) return REQUIRED_FIELDS_MESSAGE;
  if (names.length === 1) return `${names[0]} is required.`;
  if (names.length === 2) return `${names[0]} and ${names[1]} are required.`;
  return `${names.slice(0, -1).join(', ')}, and ${names[names.length - 1]} are required.`;
}

export function labelsForKeys(keys: string[], map: Record<string, string>): string[] {
  return keys.map((key) => map[key] || key);
}
